import * as React from 'react';

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    fill="none"
    {...props}
  >
    <path
      fill="#EDF0F2"
      d="M0 2a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Z"
      opacity={0.5}
    />
    <circle cx={6.5} cy={6.5} r={3.375} stroke="#3E4145" />
    <path
      fill="#3E4145"
      stroke="#3E4145"
      strokeWidth={0.7}
      d="M6.688 4.813a.188.188 0 1 1-.376 0 .188.188 0 0 1 .375 0Z"
    />
    <path stroke="#3E4145" d="M6.5 8.375V5.75" />
  </svg>
);
export default SvgComponent;
